// Client-side agent metadata for visualisation
// Names + photos + titles are also returned by GET /agents/configs (persona fields).
// The metadata here is the static fallback used when configs haven't loaded yet.
// Photos use DiceBear notionists-neutral with a uniform backgroundColor so all 11 portraits
// share the SAME illustrated style and background — no more "bende".
const DB = (seed) => `https://api.dicebear.com/9.x/notionists-neutral/svg?seed=${seed}&backgroundColor=f1f5f9&radius=50`;

export const AGENTS = [
    {
        id: "master_sales_agent", name: "Master Sales", human_name: "Vincent Peeters", title: "Sales Director",
        kind: "master", department: "sales", parent: null,
        photo_url: DB("vincent-peeters"), icon: "target",
    },
    {
        id: "master_recruiter_agent", name: "Master Recruiter", human_name: "Hannah Claes", title: "Recruitment Director",
        kind: "master", department: "recruitment", parent: null,
        photo_url: DB("hannah-claes"), icon: "users",
    },
    {
        id: "signal_scout_agent", name: "Signal Scout", human_name: "Jonas Vermeulen", title: "Sales Hunter",
        kind: "sub", department: "sales", parent: "master_sales_agent",
        photo_url: DB("jonas-vermeulen"), icon: "radar",
    },
    {
        id: "sales_outreach_agent", name: "Sales Outreach", human_name: "Charlotte Janssens", title: "Outreach & Nurture",
        kind: "sub", department: "sales", parent: "master_sales_agent",
        photo_url: DB("charlotte-janssens"), icon: "send",
    },
    {
        id: "sales_qualification_agent", name: "Sales Qualification", human_name: "Femke De Vos", title: "Account Manager",
        kind: "sub", department: "sales", parent: "master_sales_agent",
        photo_url: DB("femke-devos"), icon: "trending-up",
    },
    {
        id: "content_strategist_agent", name: "Content Strategist", human_name: "Wouter Smets", title: "Marketing Specialist",
        kind: "sub", department: "sales", parent: "master_sales_agent",
        photo_url: DB("wouter-smets"), icon: "edit-3",
    },
    {
        id: "sourcing_agent", name: "Sourcing", human_name: "Sophie Devos", title: "Talent Hunter",
        kind: "sub", department: "recruitment", parent: "master_recruiter_agent",
        photo_url: DB("sophie-devos"), icon: "search",
    },
    {
        id: "candidate_engagement_agent", name: "Candidate Engagement", human_name: "Lucas Maes", title: "Candidate Outreach",
        kind: "sub", department: "recruitment", parent: "master_recruiter_agent",
        photo_url: DB("lucas-maes"), icon: "message-circle",
    },
    {
        id: "screening_agent", name: "Screening", human_name: "Lisa Vandenberghe", title: "Interview & Evaluation",
        kind: "sub", department: "recruitment", parent: "master_recruiter_agent",
        photo_url: DB("lisa-vandenberghe"), icon: "check-square",
    },
    {
        id: "notetaker_agent", name: "Notetaker", human_name: "Thomas Janssens", title: "Intake & Notetaking",
        kind: "sub", department: "bridge", parent: "matching_agent",
        photo_url: DB("thomas-janssens"), icon: "mic",
    },
    {
        id: "profile_resolver_agent", name: "Profile Resolver", human_name: "Lars Devos", title: "LinkedIn Profile Hunter",
        kind: "sub", department: "bridge", parent: "matching_agent",
        photo_url: DB("lars-devos"), icon: "search",
    },
    {
        id: "matching_agent", name: "Matching Bridge", human_name: "Emma Hofman", title: "Matching & Onboarding",
        kind: "master", department: "bridge", parent: null,
        photo_url: DB("emma-hofman"), icon: "git-merge",
    },
];

export const AUTONOMY_LABELS = {
    1: { label: "Suggesties", short: "Suggesties", desc: "Stelt voor, mens beslist", color: "var(--jr-info)" },
    2: { label: "Approval", short: "Approval", desc: "Vraagt goedkeuring per actie", color: "var(--jr-amber)" },
    3: { label: "Autonoom", short: "Autonoom", desc: "Voert zelfstandig uit, logt alles", color: "var(--jr-brand)" },
};

export const DEPARTMENT_LABELS = {
    sales: { label: "Sales", color: "var(--jr-brand)" },
    recruitment: { label: "Recruitment", color: "var(--jr-amber)" },
    bridge: { label: "Bridge", color: "var(--jr-info)" },
};

export function agentById(id) {
    return AGENTS.find((a) => a.id === id);
}

export const ROLE_LABELS = {
    owner: { label: "Owner", color: "var(--jr-brand)", desc: "Volledige controle, billing, team." },
    admin: { label: "Admin", color: "var(--jr-amber)", desc: "Mag agents tunen + team beheren." },
    user: { label: "Operator", color: "#22c55e", desc: "Werkt met agents, geen settings-mutaties." },
    readonly: { label: "Observer", color: "var(--jr-text-2)", desc: "Alleen lezen — perfect voor klanten." },
};
